import http from "../../utility/http";

const postLoginApi = async ({ data }) => {
  const response = await http.post(`/auth/login`, data);
  return response?.data;
};

export default postLoginApi;
